const HeroSection = () => {
  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="top" className="relative w-full min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/5152a426adae95787646523e41c0d90c.webp"
          alt="岡山市の買取専門店 株式会社OTAKEの店舗内観"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-8 py-24 pt-32">
        <div
          className="max-w-2xl ml-auto bg-[#B2AC88]/50 text-right py-10 pl-10 pr-6 sm:pr-8"
          style={{ marginRight: 'calc(((100vw - min(100vw, 80rem)) / 2 + 2rem) * -1)' }}
        >
          {/* Label */}
          <div className="flex items-center justify-end gap-2 mb-6">
            <span className="text-[#468405]/80 text-xs sm:text-sm font-medium tracking-widest uppercase">
              Okayama&#39;s Eco Recycle Shop
            </span>
            <span className="w-8 h-px bg-[#B2AC88]" />
          </div>

          {/* Main Title */}
          <h1 className="text-white font-bold leading-tight mb-6" style={{ fontFamily: "'Shippori Mincho', serif" }}>
            <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-2">買取のことなら</span>
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-[#468405]">OTAKE</span>
          </h1>

          {/* Subtitle */}
          <p className="text-white/90 text-sm sm:text-base md:text-lg leading-relaxed mb-4 max-w-2xl ml-auto">
            貴金属・腕時計・ブランド品・家電・家具・記念硬貨・切手まで、
            <br />
            あなたの大切な品物に新しい価値を。
          </p>
          <p className="text-[#468405]/80 text-xs sm:text-sm mb-10">
            地球にやさしい循環型リユースで岡山市・近隣市町村のお客様をサポート
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-end">
            <a
              href="tel:086-238-7864"
              className="flex items-center justify-center gap-3 bg-[#D97706] hover:bg-[#c06a05] text-white font-bold px-8 py-4 rounded-full transition-all duration-200 text-sm sm:text-base whitespace-nowrap shadow-lg"
            >
              <i className="ri-phone-fill text-lg" />
              今すぐ電話で相談
              <span className="text-xs font-normal opacity-80">086-238-7864</span>
            </a>
            <button
              onClick={() => handleScroll('#contact')}
              className="flex items-center justify-center gap-3 bg-[#D97706]/70 hover:bg-[#D97706] border-2 border-[#D97706] hover:border-[#D97706] text-white font-bold px-8 py-4 rounded-full transition-all duration-200 text-sm sm:text-base whitespace-nowrap"
            >
              <i className="ri-mail-send-line text-lg" />
              無料査定を申し込む
            </button>
          </div>

          {/* Features */}
          <div className="flex flex-wrap gap-4 mt-10 justify-end">
            {['査定無料', '即日対応', '出張買取OK', '高価買取'].map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs px-3 py-1.5 rounded-full"
              >
                <i className="ri-check-line text-[#468405]" />
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Down */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-xs tracking-widest">SCROLL</span>
        <i className="ri-arrow-down-line text-white/60 text-lg" />
      </div>
    </section>
  );
};

export default HeroSection;
